import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const GetInfluencers = () => {
  return apiInstance.get(ApiPathConfig.INFLUENCERS)
}

export default GetInfluencers
